var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"news-title"},[_c('li',{style:({ color: _vm.titleStyle })},[_vm._v(_vm._s(_vm.title))]),_c('li',{style:({ margin: _vm.m0at ? '10px auto' : '' })}),_c('li',[_vm._v(_vm._s(_vm.news))])])
}
var staticRenderFns = []

export { render, staticRenderFns }